// polyfill de :focus-visible que adiciona uma classe .focus-visible para elementos
// que estão com foco via teclado. A propriedade não é compatívle com browser
// desatualizados https://developer.mozilla.org/en-US/docs/Web/CSS/:focus-visible
// Link do polyfill: https://github.com/WICG/focus-visible
import 'focus-visible';
import { checkFlexGap } from './platform/support';
/** O popover-polyfill adiciona a classe .\:popover-open nos browsers
 * que não suportam o popover nativamente.
 Link do polyfill: https://github.com/oddbird/popover-polyfill
*/
import '@oddbird/popover-polyfill';
import { platform } from './platform';

// aplica classe para uso de polyfills e CSS específicos para navegadores
// sem suporte a gap em flexbox
if (!checkFlexGap() && platform.isDOM) {
  document.documentElement.classList.add('js-no-flexbox-gap');
}

/*
 * Public API Surface of iDS tools
 */
export * from './a11y';
export * from './array';
export * from './components';
export * from './currency';
export * from './date';
export * from './decorator';
export * from './dev-tools';
export * from './dom';
export * from './locale';
export * from './keyboard';
export * from './motion';
export * from './object';
export * from './platform';
export * from './position';
export * from './scroll';
export * from './segment';
export * from './sort';
export * from './string';
export * from './style';
export * from './typing';
export * from './unit-converter';
export * from './virtual-keyboard';
